(function () {
  var code = window.welkomstboxDiscountCode;
  var handle = window.welkomstboxProductHandle || 'hello-sjef-special-box';
  if (!code) return;

  function cartHasWelkomstbox(cart) {
    return (cart.items || []).some(function (item) {
      return item.handle === handle;
    });
  }

  function applyDiscountIfNeeded() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cartHasWelkomstbox(cart)) return null;
        return fetch('/discount/' + encodeURIComponent(code), {
          credentials: 'same-origin',
        });
      })
      .catch(function (err) {
        console.error(err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDiscountIfNeeded);
  } else {
    applyDiscountIfNeeded();
  }
})();
